import { render, staticRenderFns } from "./TipPopup.vue?vue&type=template&id=6fa5daba&scoped=true&"
import script from "./TipPopup.vue?vue&type=script&lang=js&"
export * from "./TipPopup.vue?vue&type=script&lang=js&"
import style0 from "./TipPopup.vue?vue&type=style&index=0&id=6fa5daba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa5daba",
  null
  
)

export default component.exports